<template>
    <div>
        <p class="text-sm font-medium text-slate-700">{{ label }}</p>
        <label
            class="mt-1.5 flex min-h-[5.5rem] cursor-pointer items-center gap-3 rounded-lg border bg-white p-3 transition"
            :class="[
                error ? 'border-red-400' : dragging ? 'border-slate-900 bg-slate-50' : 'border-dashed border-slate-300 hover:border-slate-400',
            ]"
            @dragover.prevent="dragging = true"
            @dragleave.prevent="dragging = false"
            @drop.prevent="drop"
        >
            <input ref="input" type="file" class="sr-only" :accept="accept" @change="pick($event.target.files[0])" />
            <slot name="preview" />
            <span class="min-w-0 flex-1">
                <span v-if="file" class="block truncate text-sm font-medium text-slate-900">{{ file.name }}</span>
                <span v-else class="block text-sm font-medium text-slate-900">Drop a file here, or <span class="underline">browse</span></span>
                <span class="mt-0.5 block text-xs text-slate-500">{{ file ? detail || "Tap to choose a different file" : hint }}</span>
            </span>
        </label>
        <p v-if="error" class="mt-1.5 text-sm text-red-600">{{ error }}</p>
    </div>
</template>

<script>
export default {
    props: {
        label: { type: String, required: true },
        hint: { type: String, default: "" },
        detail: { type: String, default: "" },
        accept: { type: String, default: "" },
        file: { type: Object, default: null },
        error: { type: String, default: null },
    },
    emits: ["pick"],
    data() {
        return { dragging: false };
    },
    methods: {
        drop(event) {
            this.dragging = false;
            this.pick(event.dataTransfer.files[0]);
        },
        pick(file) {
            if (file) this.$emit("pick", file);
        },
    },
};
</script>
